'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useSelector } from 'react-redux';
import { CONTACT, MARKETING_CONTACT_DEPRECATED, USER } from 'self-service-api/constants/UnitTypes';
import { productVersionFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { productForSkuIdSelector, skuSelector } from '../../selectors/ProductsSelectors';
import ContactsSliderContainer from '../common/ContactsSliderContainer';
import SeatsPicker from '../common/SeatsPicker';

const AdditionalUnitsPicker = ({
  quantityPackSkuId,
  quantityPackQuantity,
  setQuantityPackQuantity,
  productConfigurations,
  setActiveProductLevel,
  compact = false,
  trackingSource,
  queryParamTerm,
  setProductConfigurations
}) => {
  const unitType = useSelector(state => {
    if (!quantityPackSkuId) return null;
    const sku = skuSelector(state, {
      skuId: quantityPackSkuId
    });
    return sku && sku.quantityUnit.unitType;
  });
  const onContactQuantityChange = useSelector(state => quantity => {
    const {
      id: currentBaseProductId,
      currentSkuId: currentBaseSkuId
    } = productForSkuIdSelector(state, {
      skuId: quantityPackSkuId
    });
    const ownedProductVersion = productVersionFromProductInventorySelector(state, {
      productAttributeFilters: {
        productId: currentBaseProductId
      }
    });
    const ownedProductSkuId = ownedProductVersion && ownedProductVersion.skuId; // If we're on a legacy Marketing SKU, we need to enforce the
    // base current SKU is added anytime quantity packs are

    if (currentBaseSkuId !== ownedProductSkuId && setProductConfigurations) {
      setProductConfigurations(() => {
        // This step removes duplicates
        const filteredConfigs = productConfigurations.filter(({
          skuId
        }) => skuId !== currentBaseSkuId && skuId !== quantityPackSkuId); // Add the appropriate base SKU

        filteredConfigs.push(createProductConfig({
          skuId: currentBaseSkuId,
          quantity: 1
        })); // Add the appropriate quantityPack SKU

        if (quantity > 0) {
          filteredConfigs.push(createProductConfig({
            skuId: quantityPackSkuId,
            quantity
          }));
        }

        return filteredConfigs;
      });
    } else {
      setQuantityPackQuantity(quantity, quantityPackSkuId);
    }
  });

  if (unitType === USER) {
    return /*#__PURE__*/_jsx(SeatsPicker, {
      quantityPackSkuId: quantityPackSkuId,
      quantityPackQuantity: quantityPackQuantity,
      onChange: setQuantityPackQuantity,
      productConfigurations: productConfigurations,
      compact: compact,
      trackingSource: trackingSource,
      queryParamTerm: queryParamTerm
    });
  } else if (unitType === CONTACT || unitType === MARKETING_CONTACT_DEPRECATED) {
    return /*#__PURE__*/_jsx(ContactsSliderContainer, {
      quantityPackSkuId: quantityPackSkuId,
      onChange: onContactQuantityChange,
      quantityPackQuantity: quantityPackQuantity,
      productConfigurations: productConfigurations,
      setProductLevel: setActiveProductLevel,
      compact: compact,
      trackingSource: trackingSource,
      queryParamTerm: queryParamTerm
    });
  }

  return null;
};

export default AdditionalUnitsPicker;